var _excluded = ["title", "image"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { isArray, isString, isObject } from 'vega-util';
var name = "vega-tooltip";
var version$1 = "0.35.2";
var description = "A tooltip plugin for Vega-Lite and Vega visualizations.";
var keywords = ["vega-lite", "vega", "tooltip"];
var repository = {
  type: "git",
  url: "https://github.com/vega/vega-tooltip.git"
};
var author = {
  name: "UW Interactive Data Lab",
  url: "https://idl.cs.washington.edu"
};
var collaborators = ["Dominik Moritz", "Sira Horradarn", "Zening Qu", "Kanit Wongsuphasawat", "Yuri Astrakhan", "Jeffrey Heer"];
var license = "BSD-3-Clause";
var bugs = {
  url: "https://github.com/vega/vega-tooltip/issues"
};
var homepage = "https://github.com/vega/vega-tooltip#readme";
var main = "build/vega-tooltip.js";
var module = "build/vega-tooltip.module.js";
var unpkg = "build/vega-tooltip.min.js";
var jsdelivr = "build/vega-tooltip.min.js";
var types = "build/src/index.d.ts";
var files = ["src", "build", "types"];
var scripts = {
  prebuild: "npm run clean && npm run build:style",
  build: "rollup -c",
  "build:style": "./build-style.sh",
  clean: "rimraf build && rimraf src/style.ts",
  "copy:data": "cp -R node_modules/vega-datasets/data examples",
  "copy:build": "cp -R build examples",
  "deploy:gh": "npm run build && npm run copy:build && gh-pages -d examples && npm run clean",
  prepublishOnly: "npm run clean && npm run build",
  preversion: "npm run lint && npm run test",
  serve: "browser-sync start -s -f build examples --serveStatic examples",
  start: "npm run build && concurrently --kill-others -n Server,Rollup 'npm run serve' 'rollup -c -w'",
  pretest: "npm run build:style",
  test: "jest",
  "test:inspect": "node --inspect-brk ./node_modules/.bin/jest --runInBand",
  prepare: "npm run copy:data",
  prettierbase: "prettier '*.{css,scss,html}'",
  format: "eslint . --fix && npm run prettierbase -- --write",
  lint: "eslint . && npm run prettierbase -- --check",
  release: "release-it"
};
var devDependencies = {
  "@babel/core": "^7.26.0",
  "@babel/plugin-proposal-async-generator-functions": "^7.20.7",
  "@babel/plugin-proposal-json-strings": "^7.18.6",
  "@babel/plugin-proposal-object-rest-spread": "^7.20.7",
  "@babel/plugin-proposal-optional-catch-binding": "^7.18.6",
  "@babel/plugin-syntax-dynamic-import": "^7.8.3",
  "@babel/plugin-transform-runtime": "^7.25.9",
  "@babel/preset-env": "^7.26.0",
  "@babel/preset-typescript": "^7.26.0",
  "@release-it/conventional-changelog": "^9.0.2",
  "@rollup/plugin-json": "^6.1.0",
  "@rollup/plugin-node-resolve": "^15.3.0",
  "@rollup/plugin-terser": "^0.4.4",
  "@rollup/plugin-typescript": "^12.1.1",
  "@types/jest": "^29.5.14",
  "@typescript-eslint/eslint-plugin": "^8.13.0",
  "@typescript-eslint/parser": "^8.13.0",
  "browser-sync": "^3.0.3",
  concurrently: "^9.1.0",
  eslint: "^8.46.0",
  "eslint-config-prettier": "^9.1.0",
  "eslint-plugin-jest": "^28.8.3",
  "eslint-plugin-prettier": "^5.2.1",
  "gh-pages": "^6.2.0",
  jest: "^29.7.0",
  "jest-environment-jsdom": "^29.7.0",
  path: "^0.12.7",
  prettier: "^3.3.3",
  "release-it": "^17.10.0",
  rollup: "^4.24.4",
  "rollup-plugin-bundle-size": "^1.0.3",
  sass: "^1.80.6",
  typescript: "~5.6.3",
  "vega-datasets": "^2.9.0",
  "vega-typings": "^1.3.1"
};
var dependencies = {
  "vega-util": "^1.17.2"
};
var optionalDependencies = {
  "@rollup/rollup-linux-x64-gnu": "^4.24.4"
};
var pkg = {
  name: name,
  version: version$1,
  description: description,
  keywords: keywords,
  repository: repository,
  author: author,
  collaborators: collaborators,
  license: license,
  bugs: bugs,
  homepage: homepage,
  main: main,
  module: module,
  unpkg: unpkg,
  jsdelivr: jsdelivr,
  types: types,
  files: files,
  scripts: scripts,
  devDependencies: devDependencies,
  dependencies: dependencies,
  optionalDependencies: optionalDependencies
};

/**
 * Format the value to be shown in the tooltip.
 *
 * @param value The value to show in the tooltip.
 * @param valueToHtml Function to convert a single cell value to an HTML string
 */
function formatValue(value, valueToHtml, maxDepth, baseURL) {
  if (isArray(value)) {
    return "[".concat(value.map(function (v) {
      return valueToHtml(isString(v) ? v : stringify(v, maxDepth));
    }).join(', '), "]");
  }
  if (isObject(value)) {
    var content = '';
    var title = value.title,
      image = value.image,
      rest = _objectWithoutProperties(value, _excluded);
    if (title) {
      content += "<h2>".concat(valueToHtml(title), "</h2>");
    }
    if (image) {
      content += "<img src=\"".concat(new URL(valueToHtml(image), baseURL || location.href).href, "\">");
    }
    var keys = Object.keys(rest);
    if (keys.length > 0) {
      content += '<table>';
      var _iterator = _createForOfIteratorHelper(keys),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var key = _step.value;
          var val = rest[key];
          // ignore undefined properties
          if (val === undefined) {
            continue;
          }
          if (isObject(val)) {
            val = stringify(val, maxDepth);
          }
          content += "<tr><td class=\"key\">".concat(valueToHtml(key), "</td><td class=\"value\">").concat(valueToHtml(val), "</td></tr>");
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      content += "</table>";
    }
    return content || '{}'; // show empty object if there are no properties
  }
  return valueToHtml(value);
}
function replacer(maxDepth) {
  var stack = [];
  return function (key, value) {
    if (_typeof(value) !== 'object' || value === null) {
      return value;
    }
    var pos = stack.indexOf(this) + 1;
    stack.length = pos;
    if (stack.length > maxDepth) {
      return '[Object]';
    }
    if (stack.indexOf(value) >= 0) {
      return '[Circular]';
    }
    stack.push(value);
    return value;
  };
}
/**
 * Stringify any JS object to valid JSON
 */
function stringify(obj, maxDepth) {
  return JSON.stringify(obj, replacer(maxDepth));
}

// generated with build-style.sh
var defaultStyle = "#vg-tooltip-element {\n  visibility: hidden;\n  padding: 8px;\n  position: fixed;\n  z-index: 1000;\n  font-family: sans-serif;\n  font-size: 11px;\n  border-radius: 3px;\n  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);\n  /* The default theme is the light theme. */\n  background-color: rgba(255, 255, 255, 0.95);\n  border: 1px solid #d9d9d9;\n  color: black;\n}\n#vg-tooltip-element.visible {\n  visibility: visible;\n}\n#vg-tooltip-element h2 {\n  margin-top: 0;\n  margin-bottom: 10px;\n  font-size: 13px;\n}\n#vg-tooltip-element table {\n  border-spacing: 0;\n}\n#vg-tooltip-element table tr {\n  border: none;\n}\n#vg-tooltip-element table tr td {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding-top: 2px;\n  padding-bottom: 2px;\n}\n#vg-tooltip-element table tr td.key {\n  color: #808080;\n  max-width: 150px;\n  text-align: right;\n  padding-right: 4px;\n}\n#vg-tooltip-element table tr td.value {\n  display: block;\n  max-width: 300px;\n  max-height: 7em;\n  text-align: left;\n}\n#vg-tooltip-element.dark-theme {\n  background-color: rgba(32, 32, 32, 0.9);\n  border: 1px solid #f5f5f5;\n  color: white;\n}\n#vg-tooltip-element.dark-theme td.key {\n  color: #bfbfbf;\n}\n";
var EL_ID = 'vg-tooltip-element';
var DEFAULT_OPTIONS = {
  offsetX: 10,
  offsetY: 10,
  id: EL_ID,
  styleId: 'vega-tooltip-style',
  theme: 'light',
  disableDefaultStyle: false,
  sanitize: escapeHTML,
  maxDepth: 2,
  formatTooltip: formatValue,
  baseURL: '',
  anchor: 'cursor',
  position: ['top', 'bottom', 'left', 'right', 'top-left', 'top-right', 'bottom-left', 'bottom-right']
};
/**
 * Escape special HTML characters.
 *
 * @param value A value to convert to string and HTML-escape.
 */
function escapeHTML(value) {
  return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;');
}
function createDefaultStyle(id) {
  // Just in case this id comes from a user, ensure these is no security issues
  if (!/^[A-Za-z]+[-:.\w]*$/.test(id)) {
    throw new Error('Invalid HTML ID');
  }
  return defaultStyle.toString().replace(EL_ID, id);
}

/**
 * Position the tooltip
 *
 * @param event The mouse event.
 * @param tooltipBox
 * @param options Tooltip handler options.
 */
function calculatePositionRelativeToCursor(event, tooltipBox, _ref) {
  var offsetX = _ref.offsetX,
    offsetY = _ref.offsetY;
  // the possible positions for the tooltip
  var positions = getPositions({
    x1: event.clientX,
    x2: event.clientX,
    y1: event.clientY,
    y2: event.clientY
  }, tooltipBox, offsetX, offsetY);
  // order of positions to try
  var postionArr = ['bottom-right', 'bottom-left', 'top-right', 'top-left'];
  // test positions till a valid one is found
  for (var _i = 0, _postionArr = postionArr; _i < _postionArr.length; _i++) {
    var p = _postionArr[_i];
    if (tooltipIsInViewport(positions[p], tooltipBox)) {
      return positions[p];
    }
  }
  // default to top-left if a valid position is not found
  // this is legacy behavior
  return positions['top-left'];
}
/**
 * Calculates the position of the tooltip relative to the mark.
 * @param handler The handler instance.
 * @param event The mouse event.
 * @param item The item that the tooltip is being shown for.
 * @param tooltipBox Client rect of the tooltip element.
 * @param options Tooltip handler options.
 * @returns
 */
function calculatePositionRelativeToMark(handler, event, item, tooltipBox, options) {
  var position = options.position,
    offsetX = options.offsetX,
    offsetY = options.offsetY;
  var containerBox = handler._el.getBoundingClientRect();
  var origin = handler._origin;
  // bounds of the mark relative to the viewport
  var markBounds = getMarkBounds(containerBox, origin, item);
  // the possible positions for the tooltip
  var positions = getPositions(markBounds, tooltipBox, offsetX, offsetY);
  // positions to test
  var positionArr = Array.isArray(position) ? position : [position];
  // test positions till a valid one is found
  var _iterator2 = _createForOfIteratorHelper(positionArr),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var p = _step2.value;
      // verify that the tooltip is in the view and the mouse is not where the tooltip would be
      if (tooltipIsInViewport(positions[p], tooltipBox) && !mouseIsOnTooltip(event, positions[p], tooltipBox)) {
        return positions[p];
      }
    }
    // default to cursor position if a valid position is not found
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return calculatePositionRelativeToCursor(event, tooltipBox, options);
}
// Calculates the bounds of the mark relative to the viewport.
function getMarkBounds(containerBox, origin, item) {
  // if this is a voronoi mark, we want to use the bounds of the point that voronoi cell represents
  var markBounds = item.isVoronoi ? item.datum.bounds : item.bounds;
  var left = containerBox.left + origin[0] + markBounds.x1;
  var top = containerBox.top + origin[1] + markBounds.y1;
  // traverse mark groups, summing their offsets to get the total offset
  // item bounds are relative to their group so if there are multiple nested groups we need to add them all
  var parentItem = item;
  while (parentItem.mark.group) {
    var _parentItem$x, _parentItem$y;
    parentItem = parentItem.mark.group;
    left += (_parentItem$x = parentItem.x) !== null && _parentItem$x !== void 0 ? _parentItem$x : 0;
    top += (_parentItem$y = parentItem.y) !== null && _parentItem$y !== void 0 ? _parentItem$y : 0;
  }
  var markWidth = markBounds.x2 - markBounds.x1;
  var markHeight = markBounds.y2 - markBounds.y1;
  return {
    x1: left,
    x2: left + markWidth,
    y1: top,
    y2: top + markHeight
  };
}
// Calculates the tooltip xy for each possible position.
function getPositions(markBounds, tooltipBox, offsetX, offsetY) {
  var xc = (markBounds.x1 + markBounds.x2) / 2;
  var yc = (markBounds.y1 + markBounds.y2) / 2;
  // x positions
  var left = markBounds.x1 - tooltipBox.width - offsetX;
  var center = xc - tooltipBox.width / 2;
  var right = markBounds.x2 + offsetX;
  // y positions
  var top = markBounds.y1 - tooltipBox.height - offsetY;
  var middle = yc - tooltipBox.height / 2;
  var bottom = markBounds.y2 + offsetY;
  var positions = {
    top: {
      x: center,
      y: top
    },
    bottom: {
      x: center,
      y: bottom
    },
    left: {
      x: left,
      y: middle
    },
    right: {
      x: right,
      y: middle
    },
    'top-left': {
      x: left,
      y: top
    },
    'top-right': {
      x: right,
      y: top
    },
    'bottom-left': {
      x: left,
      y: bottom
    },
    'bottom-right': {
      x: right,
      y: bottom
    }
  };
  return positions;
}
// Checks if the tooltip would be in the viewport at the given position
function tooltipIsInViewport(position, tooltipBox) {
  return position.x >= 0 && position.y >= 0 && position.x + tooltipBox.width <= window.innerWidth && position.y + tooltipBox.height <= window.innerHeight;
}
// Checks if the mouse is within the tooltip area
function mouseIsOnTooltip(event, position, tooltipBox) {
  return event.clientX >= position.x && event.clientX <= position.x + tooltipBox.width && event.clientY >= position.y && event.clientY <= position.y + tooltipBox.height;
}

/**
 * The tooltip handler class.
 */
var Handler = /*#__PURE__*/function () {
  /**
   * Create the tooltip handler and initialize the element and style.
   *
   * @param options Tooltip Options
   */
  function Handler(options) {
    _classCallCheck(this, Handler);
    this.options = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options);
    var elementId = this.options.id;
    this.el = null;
    // bind this to call
    this.call = this.tooltipHandler.bind(this);
    // prepend a default stylesheet for tooltips to the head
    if (!this.options.disableDefaultStyle && !document.getElementById(this.options.styleId)) {
      var style = document.createElement('style');
      style.setAttribute('id', this.options.styleId);
      style.innerHTML = createDefaultStyle(elementId);
      var head = document.head;
      if (head.childNodes.length > 0) {
        head.insertBefore(style, head.childNodes[0]);
      } else {
        head.appendChild(style);
      }
    }
  }
  /**
   * The tooltip handler function.
   */
  return _createClass(Handler, [{
    key: "tooltipHandler",
    value: function tooltipHandler(handler, event, item, value) {
      // append a div element that we use as a tooltip unless it already exists
      this.el = document.getElementById(this.options.id);
      if (!this.el) {
        var _document$fullscreenE;
        this.el = document.createElement('div');
        this.el.setAttribute('id', this.options.id);
        this.el.classList.add('vg-tooltip');
        var tooltipContainer = (_document$fullscreenE = document.fullscreenElement) !== null && _document$fullscreenE !== void 0 ? _document$fullscreenE : document.body;
        tooltipContainer.appendChild(this.el);
      }
      // hide tooltip for null, undefined, or empty string values
      if (value == null || value === '') {
        this.el.classList.remove('visible', "".concat(this.options.theme, "-theme"));
        return;
      }
      // set the tooltip content
      this.el.innerHTML = this.options.formatTooltip(value, this.options.sanitize, this.options.maxDepth, this.options.baseURL);
      // make the tooltip visible
      this.el.classList.add('visible', "".concat(this.options.theme, "-theme"));
      var _ref2 = this.options.anchor === 'mark' ? calculatePositionRelativeToMark(handler, event, item, this.el.getBoundingClientRect(), this.options) : calculatePositionRelativeToCursor(event, this.el.getBoundingClientRect(), this.options),
        x = _ref2.x,
        y = _ref2.y;
      this.el.style.top = "".concat(y, "px");
      this.el.style.left = "".concat(x, "px");
    }
  }]);
}();
var version = pkg.version;
/**
 * Create a tooltip handler and register it with the provided view.
 *
 * @param view The Vega view.
 * @param opt Tooltip options.
 */
function index(view, opt) {
  var handler = new Handler(opt);
  view.tooltip(handler.call).run();
  return handler;
}
export { DEFAULT_OPTIONS, Handler, calculatePositionRelativeToCursor, calculatePositionRelativeToMark, createDefaultStyle, index as default, escapeHTML, formatValue, getMarkBounds, getPositions, mouseIsOnTooltip, replacer, stringify, tooltipIsInViewport, version };